export default __webpack_public_path__ + "static/media/hf-logo-black.9c54cbf1.svg";